import * as angular from 'angular';
import { AncillariesUtilsService } from '../../shared/ib-web-ancillaries-utils';

export class AncillariesBaggageTransformer {
    constructor (
        private AncillariesUtilsService: AncillariesUtilsService,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private AncillariesConstants: AncillariesConstant
    ) {}

    generateAncillariesTripsBaggages = (ancilleriesBaggageInfo: any) => {
        const segmentList = [];
        if(ancilleriesBaggageInfo.slices[0]) {
            segmentList.push(ancilleriesBaggageInfo.slices[0].id);
        }
        return segmentList;
    };

    generateBaggageTripsInformation = (ancillariesSlices: any, ancillariesTripsBaggages: any, cachedData: any) => {
        const passengersBaggages = [];
        let segmentsInfo: any;
        const flowApp = this.localStorageService.get('flowApp');
        if (flowApp === this.AncillariesConstants.APPLICATION_FLOW.MMB) {
            segmentsInfo = this.AncillariesUtilsService.getMmBbookingSegmentInformation();
        } else {
            segmentsInfo = this.AncillariesUtilsService.getBookingSegmentInformation();
        }

        const getInfoSegment = (segmentId: any, segmentsInfo: any): any => {
            let i = 0, isFound = false;
            const info = { departure: null, arrival: null };
            while (i < segmentsInfo.length && !isFound) {
                if (segmentsInfo[i].id === segmentId) {
                    info.arrival = segmentsInfo[i].arrival.city;
                    info.departure = segmentsInfo[i].departure.city;
                    isFound = true;
                }
                i++;
            }
            return info;
        };

        const getInfoPassenger = (id: any): any => {
            const pasInfo: any = {},
                infantCollection = cachedData.passengers.filter((passenger) => passenger.passengerType === this.AncillariesConstants.TYPE_PASSENGER.INFANT);
            angular.forEach(cachedData.passengers, (pas) => {
                if (pas.passengerId === id) {
                    pasInfo.name = pas.externalPersonalInfo ? pas.externalPersonalInfo.name : pas.personalInfo.name;
                    pasInfo.surname = pas.externalPersonalInfo ? pas.externalPersonalInfo.firstSurname + ' ' + pas.externalPersonalInfo.lastSurname : pas.personalInfo.surname;
                } else if (pas.passengerType === this.AncillariesConstants.TYPE_PASSENGER.INFANT &&
                    infantCollection.some(infant => infant.relatedPassengerId === id)) {
                    pasInfo.infant = getRelatedInfant(id, infantCollection);
                }
            });
            return pasInfo;
        };

        const getRelatedInfant = (adultId: any, infants: any): any => {
            let adultIdInfantIndex = 0, foundedAdultInfant = false, foundedInfant = null;
            while (!foundedAdultInfant && adultIdInfantIndex < infants.length) {
                if (adultId === infants[adultIdInfantIndex].relatedPassengerId) {
                    foundedInfant = infants[adultIdInfantIndex];
                    foundedAdultInfant = true;
                }
                adultIdInfantIndex++;
            }
            return foundedInfant.personalInfo.name + ' ' + foundedInfant.personalInfo.surname;
        };

        const getInfoCkiPassenger = (id: any): any => {
            const pasInfo: any = {};
            angular.forEach(cachedData.passengers, (pas) => {
                if (pas.id.toString() === id) {
                    pasInfo.name = pas.name;
                    pasInfo.surname = pas.surname;
                    pasInfo.infant = pas.infant;
                }
            });

            return pasInfo;
        };


        for (let i = 0; i < ancillariesTripsBaggages.length; i++) {
            let isFound = false;
            if (ancillariesTripsBaggages[i].status.code === this.AncillariesConstants.STATUS.AVAILABLE) {
                angular.forEach(ancillariesTripsBaggages[i].passengers, (passengerTrip) => {
                    const passenger = {
                        id: passengerTrip.id,
                        trips: [],
                        info: this.AncillariesUtilsService.isCheckinFlow() ? getInfoCkiPassenger(passengerTrip.id) : getInfoPassenger(passengerTrip.id)
                    };
                    const trip: any = {
                        id: ancillariesTripsBaggages[i].id,
                        pieces: [],
                        maxAdditionalPieces: passengerTrip.maxAdditionalPieces,
                        piecesChoosed: 0,
                        totalPrice: 0,
                        totalBaggages: 0
                    };

                    angular.forEach(ancillariesSlices, (slice) => {
                        if (slice.id === ancillariesTripsBaggages[i].id) {
                            if (slice.segmentIds.length > 1) {
                                trip.departure = getInfoSegment(slice.segmentIds[0], segmentsInfo).departure;
                                trip.arrival = getInfoSegment(slice.segmentIds[slice.segmentIds.length - 1], segmentsInfo).arrival;
                            } else {
                                angular.extend(trip, getInfoSegment(slice.segmentIds[0], segmentsInfo));
                            }

                        }
                    });

                    angular.forEach(passengerTrip.pieces, (pasPieces) => {
                        isFound = false;
                        if (pasPieces.status.code === this.AncillariesConstants.STATUS.AVAILABLE) {
                            pasPieces.quantySelected = 0;
                            pasPieces.purchasedPieces > 0 ? trip.totalBaggages += pasPieces.purchasedPieces : angular.noop;
                            pasPieces.franchisePieces > 0 ? trip.totalBaggages += pasPieces.franchisePieces : angular.noop;
                            pasPieces.extraPieces ? trip.totalBaggages += pasPieces.extraPieces.units : angular.noop;
                            trip.pieces.push(pasPieces);

                        }
                    });

                    for (let j = 0; j < passengersBaggages.length; j++) {
                        if (passenger.id === passengersBaggages[j].id) {
                            passengersBaggages[j].trips.push(trip);
                            isFound = true;
                        }
                    }
                    if (!isFound && trip.pieces.length > 0) {
                        passenger.trips.push(trip);
                        passengersBaggages.push(passenger);
                    }
                });
            }

        }
        return passengersBaggages;
    };
}

AncillariesBaggageTransformer.$inject = ['AncillariesUtilsService', 'localStorageService', 'AncillariesConstants'];
try {
    const mod = angular.module('ib-web-ancillaries-module');
    mod.service('AncillariesBaggageTransformer', AncillariesBaggageTransformer);
} catch (error) {
    const mod = angular.module('ib-web-ancillaries-module', []);
    mod.service('AncillariesBaggageTransformer', AncillariesBaggageTransformer);
}
